export default __webpack_public_path__ + "static/media/gallery-wip-pommel_06.d4330b57.jpg";